// Import required dependencies and CSS
import React, { useState, useRef } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useHistory, Link } from "react-router-dom";
import validator from 'validator'
import './login.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TermsModal from "./TermsModal";
import HeaderLogo from '../Components/HeaderLogo/HeaderLogo'

// Define SignUp component
export const SignUp = () => {
  // Initialize state variables and hooks
  const history = useHistory();
  const [addEmail, setAddEmail] = useState('')
  const [addName, setAddName] = useState('')
  const [addKanjiName, setAddKanjiName] = useState('')
  const [addPassword, setAddPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [gender, setGender] = useState(false);
  const [birthDate, setBirthDate] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [ageError, setAgeError] = useState("");
  const today = new Date();
  const [kanjiError, setKanjiError] = useState("")
  const [furiganaError, setFuriganaError] = useState("")
  const [emailError, setEmailError] = useState("")
  const NAME_LIMIT = 50;
  const FURI_LIMIT = 50
  const EMAIL_LIMIT = 80

  const maxBirthDate = new Date(
    today.getFullYear() - 30,
    today.getMonth(),
    today.getDate()
  );

  const minBirthDate = new Date(
    today.getFullYear() - 79,
    today.getMonth(),
    today.getDate()
  );


  // age validator – called inside onChange of DatePicker
  const validateAge = date => {
    if (!date) {
      setAgeError("");
      return;
    }
    const diffMs = today.getTime() - date.getTime();
    const age = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 365.25));
    setAgeError(
      age < 30 || age > 79
        ? "サービスは30～79歳までの方のみご利用いただけます"
        : ""
    );
  };

//   const diff = today.getTime() - date.getTime();
//   const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
//   if (age < 30 || age > 70) {
//     setAgeError("サービスは30～70歳までの方のみご利用いただけます");
//   } else {
//     setAgeError("");
//   }

// const validateAge = ({date}) => {
//   if (!date) {
//     setAgeError("");
//     return;
//   }
// }

  // RadioButton component for gender selection
  const RadioButton = ({ label, value, onChange }) => {
    return (
      <label>
        <input type="radio" checked={value} onChange={onChange} />
        {label}
      </label>
    );
  };

  // Handlers for changing gender selection
  const handleMaleChange = () => {
    setGender('male');
  };

  const handleFemaleChange = () => {
    setGender('female');
  };

  const handleOtherChange = () => {
    setGender('other');
  };

  const handleCheckboxChange = () => {
    if (isChecked) {
      setIsChecked(false)
    } else {
      setIsChecked(true)
    }
  };

  // Function to validate password strength
  const validate = (value) => {
    const rx = /^[A-Za-z0-9]{8,32}$/;
    if (!rx.test(value)) {
      setPasswordError("半角英数字8-32文字で入力してください");
    } else {
      setPasswordError("");
    }
    // if (validator.isStrongPassword(value, {
    //   minLength: 8, minLowercase: 1,
    //   minUppercase: 0, minNumbers: 1, minSymbols: 0
    // })) {
    //   setErrorMessage('')
    // } else {
    //   setErrorMessage('半角英数字8-32文字')
    // }
  }

  const isFormValid =
    addEmail &&
    addName &&
    addKanjiName &&
    birthDate &&
    gender &&
    isChecked &&
    !passwordError &&
    !ageError;

  // Delay function for hiding error message
  const delay = ms => new Promise(res => setTimeout(res, ms));

  // Function to hide error message after a delay
  const disappearErrorMessageCounter = async () => {
    await delay(3000);
    setErrorMessage('')
  };

  // Handle form submission
  const handleFormSubmit = (event) => {
      event.preventDefault();
      fetch('/api/signup', {
      method: 'POST',
      body: JSON.stringify({
          patientId: null,
          email:addEmail,
          name:addName,
          kanjiName:addKanjiName,
          password:addPassword,
          gender:gender,
          birthDate:birthDate,
          consent:isChecked,
      }),
      headers: {
          "Content-Type": "application/json; charset=UTF-8"
      }
      }).then(response => response.json())
      .then(data => {
        //console.log("signup log", data)
        if (data.success) {
          history.push('/login')
        } else {
          setErrorMessage(data.error)
          disappearErrorMessageCounter()
        }
        setAddPassword('')
      })
      .catch(err=>{
        console.log("err", err);
        })
  }

  // Render SignUp component
  return (
  <>
    <HeaderLogo />
    <div className="signup-box-container">
      <form className="signup-box" onSubmit={handleFormSubmit}>
          <h3 className="login_color">サインアップ</h3>
          <div className="signup-kanji-name-label-container">
            <label>氏名*</label>
          </div>
          <input
            className="email-input"
            type="text"
            placeholder="氏名"
            onInvalid={(e) => e.preventDefault()}  //This line in all requires prevents to show the "please fill out this field" browser message when clicking on the TOS modal
            required
            maxLength={NAME_LIMIT}
            value={addKanjiName}
            onChange={e => {
              const v = e.target.value
              if (v.length > NAME_LIMIT) {
                setKanjiError(`氏名は${NAME_LIMIT}文字以内で入力してください`)
              } else {
                setKanjiError("")
                setAddKanjiName(v)
              }
            }}
          />

          {kanjiError && (
            <span className="signup-error-message-container">
              {kanjiError}
            </span>
          )}

          <div className="signup-name-label-container">
            <label>氏名(ふりがな)*</label>
          </div>
          <input
            className="email-input"
            type="text"
            placeholder="氏名（ふりがな）"
            onInvalid={(e) => e.preventDefault()}
            required
            maxLength={FURI_LIMIT}
            value={addName}
            onChange={e => {
              const v = e.target.value
              if (v.length > FURI_LIMIT) {
                setFuriganaError(`氏名（ふりがな）は${FURI_LIMIT}文字以内で入力してください`)
              } else {
                setFuriganaError("")
                setAddName(v)
              }
            }}
          />

          {furiganaError && (
            <span className="signup-error-message-container">{
              furiganaError}
              </span>
          )}

          <div className="signup-gender-label-container">
            <label>性別*</label>
            </div>
            <div className="gender-radio-buttons-container">
            <RadioButton
              label="男性"
              value={gender === 'male'}
              onChange={handleMaleChange}
            />
            <RadioButton
              label="女性"
              value={gender === 'female'}
              onChange={handleFemaleChange}
            />
            <RadioButton
              label="その他"
              value={gender === 'other'}
              onChange={handleOtherChange}
            />
          </div>

          <div className="w100p">
            <label className="signup-dob-label-container">生年月日*</label>
            <DatePicker
              className="react-datepicker__input-container"
              selected={birthDate}
              onChange={date => {
                if (!date) {
                  setBirthDate(null);
                  validateAge(null);
                  return;
                }

                // build a Date for 23:59:59 local on that calendar day so a person right before their 80th brithday can still register
                const endOfDayLocal = new Date(
                  date.getFullYear(),
                  date.getMonth(),
                  date.getDate(),
                  23, 59, 59
                );

                setBirthDate(endOfDayLocal);
                validateAge(endOfDayLocal);
              }}
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              placeholderText="DD/MM/YYYY"
              minDate={minBirthDate}
              maxDate={maxBirthDate}
            />
          </div>

          <div className="signup-email-label-container">
            <label>IDまたはメールアドレス*</label>
          </div>
          <input
          className="email-input"
          type="text"
          placeholder="メールアドレス"
          maxLength={EMAIL_LIMIT}
          onInvalid={(e) => e.preventDefault()}
          required
          value={addEmail}
          onChange={e => {
            const v = e.target.value
            if (v.length > EMAIL_LIMIT) {
              setEmailError(`メールアドレスは${EMAIL_LIMIT}文字以内で入力してください`)
            } else {
              setEmailError("")
              setAddEmail(v)
            }
          }}
          />

          {emailError && (
            <span className="signup-error-message-container">{
              emailError}
            </span>
          )}

          <div className="signup-password-label-container">
            <label>パスワード*</label>
          </div>

          <div className="password-input-container">
            <input
              className="password-input"
              type={showPassword ? "text" : "password"}
              placeholder="(半角英数字8-32文字)"
              onInvalid={(e) => e.preventDefault()}
              pattern="^[A-Za-z0-9]{8,32}$"
              title="8～32文字の半角英数字で入力してください"
              required
              value={addPassword}
              onInput={e => setAddPassword(e.target.value)}
              onChange={e => validate(e.target.value)}
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(v => !v)}
              aria-label={showPassword ? "パスワードを隠す" : "パスワードを表示"}
            >
              {showPassword ? <FaEyeSlash/> : <FaEye/>}
            </button>
          </div>

          <div style={{textAlign: "left"}}>
            *必須項目<br></br>
            ※パスワードは再発行できません。ご自身で控えて保管してください。お忘れの場合は、新たにアカウントを作成していただく必要があります。
          </div>

          <br></br>

          <div className="signup-terms-label-container">
            <label>会員規約 <span style={{ color: 'red' }}>(必須)</span></label>
            <button type="button" className="link-button" onClick={() => setIsModalOpen(true)}>会員規約を確認する</button>
            <div>
              {isModalOpen && (
                <div className="modal-overlay">
                  <div className="modal">
                    <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
                    <TermsModal onClose={() => setIsModalOpen(false)} />
                  </div>
                </div>
              )}
            </div>
            <div className="accept-terms-checkbox-label-container">
            <input type="checkbox" onChange={handleCheckboxChange} onInvalid={(e) => e.preventDefault()} required />
              <label>会員規約に同意する*</label>
            </div>
            <div style={{fontWeight: "normal"}}>
              30代~70代以外の方は現在偏差値判定をご利用いただけません。<Link to="/welcome"> トップ画面</Link>にお戻りいただき、「今すぐテスト開始」よりご利用ください。
            </div>
          </div>

          <span className="signup-error-message-container">
            {passwordError || ageError || errorMessage}
          </span>

          {/* {!errorMessage && addEmail && addName && addKanjiName && birthDate && gender && isChecked ?
            <button className="login-signup-button" type="submit">サインアップ</button>
          :
            <button className="login-signup-button-disabled" type="submit" disabled>サインアップ</button>
          } */}

          <button
            className={isFormValid ? "login-signup-button" : "login-signup-button-disabled"}
            type="submit"
            disabled={!isFormValid}
          >
            サインアップ
          </button>
        </form>
      </div>
      <h4>登録済みの方は<Link to='/login'>ログイン</Link></h4>
  </>);
}
